import React from "react";
import { useAtomValue } from "jotai";
import * as S from "./breadcrumb.style.ts";
import Link from "../Link/Link.tsx";
import { useLocation } from "react-router-dom";
import { getCurrentPageName } from "../../functions/helper.ts";
import { noBreadCrumbList } from "../../constants.ts";
import { ownerPayConfigAtom } from "../../hook/OwnerPayConfigAtom.ts";
import { modeLabels } from "../../functions/cashflowCopy.ts";

const Breadcrumb = () => {
  const { pathname } = useLocation();
  const ownerPayConfig = useAtomValue(ownerPayConfigAtom);
  const { ownerPayPageTitle } = modeLabels(ownerPayConfig);
  const { pageName, page2Name } = getCurrentPageName(
    pathname,
    ownerPayPageTitle,
  );
  const isAccount = pathname.includes("/account/");

  if (noBreadCrumbList.includes(pathname)) {
    return <></>;
  }

  return (
    <S.Wrapper>
      {page2Name && (
        <>
          <S.GreyedOut>
            <Link url={isAccount ? `/account` : `/cash-flow`} label={page2Name}>
              {page2Name}
            </Link>
          </S.GreyedOut>
          <S.GreyedOut>&gt;</S.GreyedOut>
        </>
      )}
      <div>{pageName}</div>
    </S.Wrapper>
  );
};

export default Breadcrumb;
